"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwPodElement = _interopRequireDefault(require("./CwPodElement.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var CwPodElement = function CwPodElement(props) {
  var _cx;

  if (props.ghostPodElement) {
    return _react.default.createElement("div", {
      className: _CwPodElement.default.wrap
    });
  }

  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_CwPodElement.default.wrap, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwPodElement.default.label, props.label), (0, _defineProperty2.default)(_cx, _CwPodElement.default.required, props.label && props.isRequired), (0, _defineProperty2.default)(_cx, _CwPodElement.default.labelinvalid, props.label && props.invalid), (0, _defineProperty2.default)(_cx, _CwPodElement.default.labelblue, props.label && props.labelBlue), _cx))
  }, props.label, props.widget);
};

CwPodElement.propTypes = {
  labelBlue: _propTypes.default.bool,
  label: _propTypes.default.element,
  isRequired: _propTypes.default.bool,
  invalid: _propTypes.default.bool,
  widget: _propTypes.default.element,
  ghostPodElement: _propTypes.default.bool
};
var _default = CwPodElement;
exports.default = _default;